module.exports = __webpack_public_path__ + "img/restaurant-14.e39d9955.jpg";